import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoginRequest } from '../../models/login/login.request';
import { Router } from '@angular/router';
import { LoginErrorModel } from '../../models/login/LoginErrorModel';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../config.service';
import { LogoutInfoModel } from '../../models/login/logout-info.model';
import { Observable } from 'rxjs';
import { TaskResult } from '../../models/client-models';
import { AuthenticationModel } from '../../models/login/authentication.model';

const AUTH_ENDPOINT = 'authentication';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private translate: TranslateService
  ) {}

  getListPrivacySettings() {
    return this.http.get<boolean>(
      AppConfig.settings.backend.url + AUTH_ENDPOINT + '/listprivacy'
    );
  }

  getVisumTimeSetting() {
    return this.http.get<boolean>(
      AppConfig.settings.backend.url + AUTH_ENDPOINT + '/visumSetting'
    );
  }

  login(loginRequest: LoginRequest): Observable<AuthenticationModel> {
    return this.http.post<AuthenticationModel>(
      AppConfig.settings.backend.url + AUTH_ENDPOINT,
      loginRequest
    );
  }

  logout(logoutInfo: LogoutInfoModel): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + AUTH_ENDPOINT + '/logout',
      logoutInfo
    );
  }

  checkInputUser(inputValue: string): Observable<boolean> {
    return this.http.get<boolean>(
      AppConfig.settings.backend.url +
        AUTH_ENDPOINT +
        '/checkInput?inputValue=' +
        inputValue
    );
  }

  handleError(error: HttpErrorResponse): LoginErrorModel {
    let result: LoginErrorModel;
    if (error.error) {
      result = error.error;
    } else {
      let message = this.translate
        .get('error.default')
        .pipe()
        .subscribe((str) => (message = str))
        .unsubscribe();
      result = {
        general: message,
        personalNR: '',
        password: '',
      };
    }
    return result;
  }
}
